<ng-container>
	<div fxLayout="column" style="padding:16px;">
		<!-- <div style="margin:16px;" fxFlex="1094px" fxFlex.lt-md="100" fxLayout="column"> -->
		<!-- <div style="margin:16px;" fxFlex="1094px" fxFlex.lt-md="100" fxLayout="column"> -->
		<div fxFlex="5" style="background-color: #242424;">
			<div style="padding:16px; color: #ffffff;">
				<div data-idtest="home-t-9Co" class="card-title" translate>会員情報</div>
			</div>
		</div>

		<div fxFlex.lt-md="100" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="center center" style="padding-top:32px;">
			<!--		<div fxFlex="360px" fxFlex.lt-md="0" fxFlex.lt-sm="0">
						<div [queryParams]="params" fxFlex="100" routerLink="/profile" style="text-decoration: none;">
							<mat-card data-idtest="home-b-6Xk" mat-ripple class="card" style="cursor: pointer">
								<div fxLayout="row" fxLayoutAlign="space-around none" style="height: 100%;">
									<div fxFlex="35" fxLayoutAlign="center center">
										<mat-icon class="icon" mat-list-icon>person</mat-icon>
									</div>
									<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start">
										<div data-idtest="home-t-9Ne" class="title" translate>旧プロフィール</div>
										<div data-idtest="home-t-3Wx" class="text" translate>プロフィール情報の変更</div>
									</div>
								</div>
							</mat-card>
						</div>
					</div> -->

			<div fxFlex="360px" fxFlex.lt-md="0" fxFlex.lt-sm="0">
				<div [queryParams]="params" fxFlex="100" routerLink="/profile2" style="text-decoration: none;">
					<mat-card data-idtest="home-b-1Nj" mat-ripple class="card" style="cursor: pointer">
						<div fxLayout="row" fxLayoutAlign="space-around none" style="height: 100%;">
							<div fxFlex="35" fxLayoutAlign="center center">
								<mat-icon data-idtest="home-a-0Zb" class="icon" mat-list-icon>person</mat-icon>
							</div>
							<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start">
								<div data-idtest="home-t-5Gn" class="title" translate>プロフィール</div>
								<div data-idtest="home-t-1Lk" class="text" translate>プロフィール情報の変更</div>
							</div>
						</div>
					</mat-card>
				</div>
			</div>

			<div fxFlex="360px" fxFlex.lt-md="0" fxFlex.lt-sm="0">
				<div aigia-password-button fxFlex="100" style="text-decoration: none;  cursor:pointer">
					<mat-card data-idtest="home-b-7Ei" mat-ripple class="card" style="cursor: pointer">
						<div fxLayout="row" fxLayoutAlign="space-around none" style="height: 100%;">
							<div fxFlex="35" fxLayoutAlign="center center">
								<mat-icon data-idtest="home-a-7Vv" class="icon" mat-list-icon>lock</mat-icon>
							</div>
							<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start">
								<div class="title" translate>パスワード</div>
								<div class="text" translate>パスワードの変更</div>
							</div>
						</div>
					</mat-card>
				</div>
			</div>

			<div fxFlex="360px" fxFlex.lt-md="0" fxFlex.lt-sm="0">
		<!--	<div *ngIf="pay_accounts.length === 0" fxFlex="360px" fxFlex.lt-md="0" fxFlex.lt-sm="0"> -->
				<div [queryParams]="params" fxFlex="100" routerLink="/payment" style="text-decoration: none;">
					<mat-card data-idtest="home-b-7If" mat-ripple class="card" style="cursor: pointer">
						<div fxLayout="row" fxLayoutAlign="space-around none" style="height: 100%;">
							<div fxFlex="35" fxLayoutAlign="center center">
								<mat-icon data-idtest="home-a-4Mo" class="icon" mat-list-icon>credit_card</mat-icon>
							</div>
							<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start">
								<div data-idtest="home-t-9Je" class="title" translate>お支払い情報</div>
								<div data-idtest="home-t-1Gj" class="text" translate>お支払い情報の変更</div>
							</div>
						</div>
					</mat-card>
				</div>
			</div>
		</div>
	</div>
</ng-container>
